import { DockAppointment } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'dock-appointment';

export class DockAppointmentController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getAppointmentForStop(
    shipmentStopId: number,
  ): Promise<DockAppointment> {
    const response = await this.http.get<DockAppointment>(
      `stop/${shipmentStopId}`,
    );
    return new DockAppointment(response.data);
  }
}
